import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { apiFetch } from '../designer/config/api';
import logoApp from '../assets/logoapp.png';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const savedEmail = localStorage.getItem('savedEmail');
        const savedPassword = localStorage.getItem('savedPassword');
        if (savedEmail && savedPassword) {
            setEmail(savedEmail);
            setPassword(savedPassword);
            setRememberMe(true);
        }
    }, []);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const data = await apiFetch('/api/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });

            if (data.Success) {
                localStorage.setItem('userRole', 'Super Admin');
                localStorage.setItem('userName', data.Name);
                localStorage.setItem('accountId', data.AccountId);
                localStorage.setItem('token', data.Token);

                if (rememberMe) {
                    localStorage.setItem('savedEmail', email);
                    localStorage.setItem('savedPassword', password);
                } else {
                    localStorage.removeItem('savedEmail');
                    localStorage.removeItem('savedPassword');
                }

                navigate('/dashboard');
            } else {
                alert(data.Message || 'Login failed');
            }
        } catch (error: any) {
            console.error('Login error:', error);
            alert(error.message || 'Connection error');
        }
    };

    return (
        <div className="auth-wrapper">
            <div className="auth-container">
                <div className="brand-header" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <img src={logoApp} alt="Matica Logo" style={{ maxWidth: '200px', marginBottom: '15px' }} />
                    <p>Printer Management System</p>
                </div>

                <div className="auth-card">
                    <h3>Welcome Back</h3>
                    <p className="auth-subtitle">Login to your account</p>

                    <form onSubmit={handleLogin}>
                        <div className="form-group">
                            <label>Email Address</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="name@company.com"
                            />
                        </div>
                        <div className="form-group">
                            <label>Password</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="••••••••"
                            />
                        </div>
                        <div className="form-group" style={{ flexDirection: 'row', alignItems: 'center', gap: '8px', marginBottom: '20px' }}>
                            <input
                                type="checkbox"
                                id="rememberMe"
                                checked={rememberMe}
                                onChange={(e) => setRememberMe(e.target.checked)}
                                style={{ width: 'auto', margin: 0 }}
                            />
                            <label htmlFor="rememberMe" style={{ margin: 0, cursor: 'pointer', userSelect: 'none' }}>Recordar usuario y contraseña</label>
                        </div>
                        <button type="submit" className="btn-primary full-width">Sign In</button>
                    </form>

                    <div className="auth-footer">
                        <p>Don't have an account? <Link to="/register">Create Account</Link></p>
                    </div>
                </div>
            </div>
        </div>
    );
}
